import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { privateAPI } from '../util/api'; // Импортируем ваш API для POST-запросов

const CreateWebhook = () => {
  const navigate = useNavigate();
  const [webhookName, setWebhookName] = useState('');
  const [service, setService] = useState(''); // Telegram или Bybit
  const [botToken, setBotToken] = useState('');
  const [chatId, setChatId] = useState('');
  const [apiKey, setApiKey] = useState('');
  const [apiSecret, setApiSecret] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  // Функция для обработки отправки формы
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const payload = {
        name: webhookName,
        service,
        ...(service === 'telegram' && { bot_token: botToken, chat_id: chatId }),
        ...(service === 'bybit' && { api_key: apiKey, api_secret: apiSecret }),
      };

      const response = await privateAPI.post('/webhook', payload);

      if (response.status === 200) {
        setSuccessMessage('Webhook created successfully!');
        setTimeout(() => {
          navigate('/dashboard');
        }, 2000); // Переход на страницу dashboard через 2 секунды
      } else {
        throw new Error('Failed to create webhook');
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'An error occurred. Please try again.');
      // Удаление ошибки через 3 секунды
      setTimeout(() => {
        setError('');
      }, 3000);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex justify-center items-start mt-12"> {/* Отступ сверху от navbar */}
      <div className="w-full max-w-lg p-6 bg-white shadow-md rounded-md">
        <h1 className="text-2xl font-semibold mb-4 text-center">Create Webhook</h1>

        {error && (
          <div className="text-red-500 mb-4 text-center">
            {error}
          </div>
        )}

        {successMessage && (
          <div className="text-green-500 mb-4 text-center">
            {successMessage}
          </div>
        )}

        <form onSubmit={handleSubmit} className={`${isSubmitting && 'opacity-50 pointer-events-none'}`}>
          <div className="mb-4">
            <label className="block text-gray-700">Webhook Name</label>
            <input
              type="text"
              className="w-full mt-2 p-2 border rounded-md"
              value={webhookName}
              onChange={(e) => setWebhookName(e.target.value)}
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700">Service</label>
            <select
              className="w-full mt-2 p-2 border rounded-md"
              value={service}
              onChange={(e) => setService(e.target.value)}
              required
            >
              <option value="">Select Service</option>
              <option value="telegram">Telegram</option>
              <option value="bybit">Bybit</option>
            </select>
          </div>

          {/* Поля для Telegram */}
          {service === 'telegram' && (
            <>
              <div className="mb-4">
                <label className="block text-gray-700">Bot Token</label>
                <input
                  type="text"
                  className="w-full mt-2 p-2 border rounded-md"
                  value={botToken}
                  onChange={(e) => setBotToken(e.target.value)}
                  required
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700">Chat ID</label>
                <input
                  type="text"
                  className="w-full mt-2 p-2 border rounded-md"
                  value={chatId}
                  onChange={(e) => setChatId(e.target.value)}
                  required
                />
              </div>
            </>
          )}

          {/* Поля для Bybit */}
          {service === 'bybit' && (
            <>
              <div className="mb-4">
                <label className="block text-gray-700">API Key</label>
                <input
                  type="text"
                  className="w-full mt-2 p-2 border rounded-md"
                  value={apiKey}
                  onChange={(e) => setApiKey(e.target.value)}
                  required
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700">API Secret</label>
                <input
                  type="text"
                  className="w-full mt-2 p-2 border rounded-md"
                  value={apiSecret}
                  onChange={(e) => setApiSecret(e.target.value)}
                  required
                />
              </div>
            </>
          )}

          <div className="flex justify-center">
            <button
              type="submit"
              className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-500"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Save Webhook'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateWebhook;